import { render } from "./TransactionTable.vue?vue&type=template&id=590aa6ab"
import script from "./TransactionTable.vue?vue&type=script&lang=js"
export * from "./TransactionTable.vue?vue&type=script&lang=js"

import "./TransactionTable.vue?vue&type=style&index=0&id=590aa6ab&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__